import { styled } from "styled-components";

export const RecommendationButton = styled.button`
  width: 65px;
  padding: 8px 16px;
  border: none;
  background-color: #f0f0f0;
  cursor: pointer;
  &:hover {
    background-color: #e0e0e0;
  }
`;
